module.exports = __webpack_public_path__ + "assets/lftlay.934c7881.svg";